import { jsPDF } from "jspdf";

export const downloadChatHistory = (messages) => {
  if (!Array.isArray(messages) || messages.length === 0) {
    console.warn("⚠️ No chat history available to export.");
    return;
  }

  // ✅ Create a new PDF doc
  const doc = new jsPDF();

  // ---------- Title ----------
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Laurence's AI Assistant - Chat History", 10, 15);

  // ---------- Time Format ----------
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "Unknown Time";
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return "Unknown Time";
    return date.toLocaleString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // ---------- Chat Start & End ----------
  const startTime = formatTimestamp(messages[1].timestamp);
  const endTime = formatTimestamp(messages[messages.length - 1].timestamp);

  doc.setFontSize(12);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(100, 100, 100);

  doc.text(`Chat Start: ${startTime}`, 10, 25);
  doc.text(`Chat End: ${endTime}`, 10, 32);

  let y = 45;

  // ---------- Iterate through messages ----------
  messages.forEach((msg) => {
    if (!msg?.content) return;

    const isUser = msg.role === "user";
    // Choose color + style for AI vs user
    doc.setFont("helvetica", isUser ? "normal" : "bold");
    doc.setFontSize(12);

    // AI = bold blue, user = normal black/grey
    const textColor = isUser ? [50, 50, 50] : [0, 0, 255]; // user=grayish, AI=blue
    doc.setTextColor(...textColor);

    // Make the line: e.g. "AI: Hello world"
    const prefix = isUser ? "You: " : "AI: ";
    const text = prefix + msg.content;

    // Print the text
    const lineHeight = 7; // slightly bigger line height
    const lines = doc.splitTextToSize(text, 180);

    lines.forEach((line) => {
      doc.text(line, 10, y);
      y += lineHeight;

      if (y > 270) {
        doc.addPage();
        y = 20;
      }
    });

    // extra gap between messages
    y += 3;
  });

  // ---------- Save PDF ----------
  doc.save("Laurence_AI_Chat_History.pdf");
};
